import classNames from 'classnames';
import styles from './RichText.module.scss';
const camelCase = str => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
const upperFirst = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : str);
const camelCaseKeys = (attributes = {}) => Object.entries(attributes).reduce((updatedKeyObject, [key, value]) => (Object.assign(Object.assign({}, updatedKeyObject), { [camelCase(key)]: value })), {});
export const extractInlineStyles = ({ attributes = {} }) => {
    const { color, textAlign, marginLeft } = camelCaseKeys(attributes);
    return { color, textAlign, marginLeft };
};
export const extractChildElementInlineStyles = (node, elementStyle, index = 0) => {
    var _a;
    if (!node)
        return {};
    if (((_a = node.children[index]) === null || _a === void 0 ? void 0 : _a.style) !== elementStyle)
        return {};
    return extractInlineStyles(node.children[index]);
};
export const getCustomFontStyle = ({ fontSize, fontWeight, fontFamily }) => {
    const hasCustomStyling = !!(fontSize || fontWeight || fontFamily);
    if (hasCustomStyling) {
        return {
            fontFamilyValue: fontFamily,
            fontSizeValue: fontSize,
            fontWeightValue: fontWeight,
            hasFontFamily: !!fontFamily,
            hasFontSize: !!fontSize,
            hasFontWeight: !!fontWeight,
            useBaseClass: false,
        };
    }
    return {
        hasFontFamily: false,
        hasFontSize: false,
        hasFontWeight: false,
        useBaseClass: true,
    };
};
export const buildElementStyling = ({ baseClass = '', value = {} } = {}) => {
    const { attributes = {}, isLastItem = false } = value;
    const keys = camelCaseKeys(attributes);
    const { fontSize, fontWeight, font: fontFamily } = keys;
    const inlineStyles = extractInlineStyles({ attributes });
    const { fontFamilyValue, fontSizeValue, fontWeightValue, hasFontSize, hasFontFamily, hasFontWeight, useBaseClass, } = getCustomFontStyle({
        fontFamily,
        fontSize,
        fontWeight,
    });
    return {
        className: classNames({
            [styles[baseClass]]: useBaseClass && baseClass,
            [styles[`fontSize${fontSizeValue && fontSizeValue.replace('.0px', 'px')}`]]: hasFontSize,
            [styles[`fontWeight${upperFirst(fontWeightValue)}`]]: hasFontWeight,
            [styles[fontFamilyValue]]: hasFontFamily,
            [styles.noMargin]: isLastItem,
        }),
        style: inlineStyles,
    };
};
export const getNewLineCharacterCount = str => {
    const re = /\r\n|\r|\n/g;
    return ((str && str.match(re)) || []).length;
};
const getLastItemVisually = ({ richTextBlocks, index }) => {
    const numberOfItems = richTextBlocks.length;
    const isLastItem = index === numberOfItems - 1;
    const isBeforeLastItem = index === numberOfItems - 2;
    const lastItem = richTextBlocks === null || richTextBlocks === void 0 ? void 0 : richTextBlocks[numberOfItems - 1];
    const lastItemIsSpan = ((lastItem === null || lastItem === void 0 ? void 0 : lastItem.type) || (lastItem === null || lastItem === void 0 ? void 0 : lastItem._type)) === 'span';
    const lastItemIsEmptyLine = getNewLineCharacterCount(lastItem === null || lastItem === void 0 ? void 0 : lastItem.text) === 1;
    const lastItemIsSpanWithEmptyLine = lastItemIsSpan && lastItemIsEmptyLine;
    return ((isBeforeLastItem && lastItemIsSpanWithEmptyLine) ||
        (isLastItem && !lastItemIsSpanWithEmptyLine));
};
export const richTextSerializer = (richTextBlocks = []) => {
    try {
        const blocks = richTextBlocks.map((block, index) => {
            const isSpanText = block.type === 'span' && !!block.text;
            return Object.assign(Object.assign(Object.assign({}, block), (isSpanText && { mark: 'span' })), { isLastItem: getLastItemVisually({ richTextBlocks, index }), _key: `block-${index}` });
        });
        const blocksAsString = JSON.stringify(blocks);
        const blocksWithReplacedType = blocksAsString.replace(/"type"/g, '"_type"');
        return JSON.parse(blocksWithReplacedType);
    }
    catch (error) {
        return [];
    }
};
//# sourceMappingURL=utils.js.map